import { useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { SignIn } from '@clerk/clerk-react'
import { useAuth } from '@/hooks/useAuth'
import { LoadingSpinner } from '@/components/ui/LoadingSpinner'
import { motion } from 'framer-motion'

const fade = { initial: { opacity: 0, y: 10 }, animate: { opacity: 1, y: 0 } }

export function LoginPage() {
  const navigate = useNavigate()
  const { isAuthenticated, isLoading } = useAuth()

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/dashboard', { replace: true })
    }
  }, [isAuthenticated, navigate])

  if (isLoading) {
    return (
      <div className="w-full flex items-center justify-center min-h-[400px]">
        <LoadingSpinner size="lg" />
      </div>
    )
  }

  return (
    <div className="w-full">
      <motion.h2 {...fade} transition={{ duration: 0.5, delay: 0.1 }} className="text-2xl font-bold text-white">
        Welcome back
      </motion.h2>
      <motion.p {...fade} transition={{ duration: 0.5, delay: 0.2 }} className="text-sm text-white/50 mb-8">
        Sign in to continue
      </motion.p>

      <motion.div {...fade} transition={{ duration: 0.5, delay: 0.3 }}>
        <SignIn
          routing="path"
          path="/auth/login"
          signUpUrl="/auth/register"
          appearance={{
            elements: {
              rootBox: 'w-full',
              card: 'bg-transparent shadow-none p-0 w-full',
              headerTitle: 'hidden',
              headerSubtitle: 'hidden',
              socialButtonsBlockButton: 'bg-white/[0.06] border-white/[0.08] text-white hover:bg-white/[0.1]',
              formFieldInput: 'bg-white/[0.06] border-white/[0.08] text-white placeholder:text-white/30',
              formFieldLabel: 'text-white/60',
              formButtonPrimary: 'bg-primary-400 text-dark-500 hover:bg-primary-300',
              footerActionLink: 'text-white/60 hover:text-white',
              identityPreviewEditButton: 'text-white/60',
              formFieldAction: 'text-white/60',
              dividerLine: 'bg-white/10',
              dividerText: 'text-white/30',
              footer: 'hidden',
            },
          }}
        />
      </motion.div>

      {/* Divider */}
      <div className="my-8 relative">
        <div className="absolute inset-0 flex items-center">
          <div className="w-full border-t border-white/10" />
        </div>
        <div className="relative flex justify-center text-xs">
          <span className="px-3 bg-[#0C1319] text-white/30">or</span>
        </div>
      </div>

      <p className="text-sm text-center text-white/40">
        Don&apos;t have an account?{' '}
        <Link to="/auth/register" className="text-white/60 hover:text-white transition-colors">
          Start free trial
        </Link>
      </p>
    </div>
  )
}
